import request from './request';

export function like(id, type) {
  return request('post', `/apiv2/${type}/${id}/like`);
}

//Show in modal of likes
export function likes(id, type, params) {
  return request('get', `/apiv2/${type}/${id}/all-likes`, params);
}
